import { DestroyRef, EventEmitter, inject, PLATFORM_ID } from "@angular/core";
import { InputTextInstruction, InputTextareaInstruction } from '@common/instructions/frontend-shared';
import { FeedbackItem } from "@common/feedback/shared";
import { DynamicFieldsetModule, FormServiceSaveHandlerSubmitOnlyApiItem, FsOnAfterSaveEvent, ModelFormService, ModelFormServiceFactory } from '@common/forms/frontend-shared';
import { AccessService, ConfigService, takeWhileAlive } from '@core/frontend-shared';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from "@angular/router";
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { filter } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@common/forms/frontend-shared";
import * as i2 from "@core/frontend-shared";
import * as i3 from "@common/ui/frontend-shared/panel";
import * as i4 from "../../../../../forms/frontend-shared/src/lib/simple-fieldset/simple-fieldset.component";
import * as i5 from "../../../../../forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
const _c0 = () => ({
  label: "Senden",
  icon: "chevron-right"
});
function FeedbackFormComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-panel", 1);
    i0.ɵɵelement(1, "simple-fieldset", 2);
    i0.ɵɵelementStart(2, "p")(3, "small");
    i0.ɵɵtext(4, "* Dieses Feld ist ein Pflichtfeld.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "small");
    i0.ɵɵtext(7, "Ihre Angaben werden zur Optimierung unseres Produktes und ggf. R\u00FCckfragen genutzt. ");
    i0.ɵɵelementStart(8, "a", 3);
    i0.ɵɵtext(9, "Datenschutz");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "ui-footer");
    i0.ɵɵelement(11, "button", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("header", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructions", ctx_r0.instructions)("formService", ctx_r0.formService);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.formService)("formSubmitButtonOptions", i0.ɵɵpureFunction0(5, _c0));
  }
}
function FeedbackFormComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "simple-fieldset", 2);
    i0.ɵɵelementStart(1, "p")(2, "small");
    i0.ɵɵtext(3, "* Dieses Feld ist ein Pflichtfeld.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "small");
    i0.ɵɵtext(6, "Ihre Angaben werden zur Optimierung unseres Produktes und ggf. R\u00FCckfragen genutzt. ");
    i0.ɵɵelementStart(7, "a", 3);
    i0.ɵɵtext(8, "Datenschutz");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 5);
    i0.ɵɵelement(10, "button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("instructions", ctx_r0.instructions)("formService", ctx_r0.formService);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.formService)("formSubmitButtonOptions", i0.ɵɵpureFunction0(4, _c0));
  }
}
function FeedbackFormComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FeedbackFormComponent_Conditional_0_Conditional_0_Template, 12, 6, "ui-panel", 1)(1, FeedbackFormComponent_Conditional_0_Conditional_1_Template, 11, 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.removeTheming ? 0 : 1);
  }
}
function FeedbackFormComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 0);
    i0.ɵɵtext(1, " Vielen Dank f\u00FCr Ihr Feedback! ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("noMargin", true);
  }
}
export let FeedbackFormComponent = /*#__PURE__*/(() => {
  class FeedbackFormComponent {
    constructor(formServiceFactory, access, config) {
      this.destroyRef = inject(DestroyRef);
      this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
      this.showThanks = false;
      this.title = 'Feedback senden';
      this.removeTheming = false;
      this.formSent = new EventEmitter();
      this.instructions = [new InputTextInstruction({
        formControlName: 'name',
        placeholder: 'Ihr Name *'
      }), new InputTextInstruction({
        formControlName: 'email',
        placeholder: 'Email-Adresse *'
      }), new InputTextareaInstruction({
        formControlName: 'message',
        placeholder: 'Ihre Nachricht *'
      })];
      let immutableData = {};
      if (this.isBrowser) {
        immutableData = {
          url: window.location.pathname + window.location.search,
          userAgent: window.navigator.userAgent,
          version: config.get('version')
        };
      }
      ;
      const defaultData = {};
      const userData = access.getAccessData('user');
      if (access.isLoggedIn && userData) {
        immutableData.ownerId = userData.id || null;
        defaultData.name = userData.firstName + ' ' + userData.lastName;
      }
      const formService = formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(FeedbackItem);
      formService.setSaveHandler(FormServiceSaveHandlerSubmitOnlyApiItem);
      formService.setImmutableValues(immutableData);
      formService.setInitialValue(defaultData);
      formService.events$.pipe(takeWhileAlive(), filter(e => e instanceof FsOnAfterSaveEvent)).subscribe(({
        error
      }) => {
        if (!error) this.afterSubmit();
      });
      formService.initialize();
      this.formService = formService;
    }
    afterSubmit() {
      this.showThanks = true;
      this.formSent.emit(null);
    }
    static {
      this.ɵfac = function FeedbackFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeedbackFormComponent)(i0.ɵɵdirectiveInject(i1.ModelFormServiceFactory), i0.ɵɵdirectiveInject(i2.AccessService), i0.ɵɵdirectiveInject(i2.ConfigService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: FeedbackFormComponent,
        selectors: [["feedback-form"]],
        hostVars: 2,
        hostBindings: function FeedbackFormComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("remove-theming", ctx.removeTheming);
          }
        },
        inputs: {
          title: "title",
          removeTheming: "removeTheming"
        },
        outputs: {
          formSent: "formSent"
        },
        decls: 2,
        vars: 2,
        consts: [["type", "success", "styleClass", "thanks", 3, "noMargin"], [3, "header"], [3, "instructions", "formService"], ["routerLink", "/privacy"], ["type", "submit", "uiButton", "", 3, "formSubmitButton", "formSubmitButtonOptions"], [1, "ui-margin"], ["type", "submit", "e2e-submit-feedback", "", "uiButton", "", 3, "formSubmitButton", "formSubmitButtonOptions"]],
        template: function FeedbackFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, FeedbackFormComponent_Conditional_0_Template, 2, 1);
            i0.ɵɵconditionalCreate(1, FeedbackFormComponent_Conditional_1_Template, 2, 1, "ui-message", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.showThanks ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showThanks ? 1 : -1);
          }
        },
        dependencies: [i3.UiPanelComponent, i3.UiFooterComponent, DynamicFieldsetModule, i4.SimpleFieldsetComponent, i5.FormSubmitButtonDirective, RouterLink, UiButtonComponent, UiMessageComponent],
        encapsulation: 2
      });
    }
  }
  return FeedbackFormComponent;
})();